<div class="app-admin-wrap layout-sidebar-plain clearfix" [ngClass]="{'sidenav-open': navService.sidebarState.sidenavOpen}">
  <!-- Backdrop overlay for mobile -->
  <div class="sidebar-backdrop" *ngIf="navService.sidebarState.sidenavOpen" (click)="toggleSidebar()"></div>
  
  <div class="side-content-wrap" [ngClass]="{'sidebar-hidden': !navService.sidebarState.sidenavOpen}">
    <app-sidebar-plain></app-sidebar-plain>
  </div>
  <div class="main-content-wrap d-flex flex-column">
    <app-header-sidebar-plain></app-header-sidebar-plain>
    <div class="main-content">
      <router-outlet></router-outlet>
    </div>
    <div class="flex-grow-1"></div>
    <app-footer></app-footer>
    @if (moduleLoading) {
      <div class="module-loader">
        <div class="spinner spinner-bubble spinner-bubble-primary me-3"></div>
      </div>
    }
  </div>
</div>
@if (searchService.searchOpen) {
  <app-search></app-search>
}